import React from "react";
import SearchBar from "./bar";
import SearchResults from "./results";
import SearchAttribution from "./attribution";

export default function SearchContainer() {
  return (
    <div className="dewey--search--container--wrapper">
      <div className="dewey--search--container">
        <SearchBar />
        <SearchResults />
        <SearchAttribution />
      </div>
    </div>
  );
}
